var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-layout" },
    _vm._l(_vm.sections, function(section, k) {
      return _c(
        "div",
        { key: k, staticClass: "col-12 col-md-12 px-0 layout-section" },
        [
          _c(
            "div",
            { staticClass: "mr-md-4 pb-2 rounded" },
            [
              section !== "untitled"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "section-heading-top py-2 mt-1 mb-2 pl-2 product-section-heading text-white rounded-top"
                    },
                    [
                      _c("section-heading", {
                        attrs: {
                          section: section,
                          pageData: _vm.pageData,
                          headingType: "top"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scrolling-wrapper pt-3 bg-white" },
                _vm._l(_vm.subSections, function(subSection, k) {
                  return _vm.group[section][subSection] &&
                    subSection === "untitled"
                    ? _c(
                        "div",
                        { key: k, staticClass: "cardItem col-md-3" },
                        _vm._l(
                          _vm.group[section][subSection]["untitled"],
                          function(fieldData, m) {
                            return _c("form-block", {
                              key: m,
                              staticClass: "form-group mx-3",
                              attrs: { formdata: fieldData, formIndex: m }
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              [
                _c(
                  "div",
                  {
                    ref: "carousel-vehicle-top-scrollbar",
                    refInFor: true,
                    staticClass: "scrolling-wrapper pb-2 bg-white",
                    attrs: { id: "carousel-vehicle-top-scrollbar" }
                  },
                  _vm._l(_vm.subSections, function(subSection, j) {
                    return _vm.group[section][subSection] &&
                      subSection !== "untitled"
                      ? _c("div", { key: j, staticClass: "cardItem col-md-3" })
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "carousel-vehicle-headings",
                    refInFor: true,
                    staticClass: "scrolling-wrapper pt-3 bg-white",
                    attrs: { id: "carousel-vehicle-headings" }
                  },
                  _vm._l(_vm.subSections, function(subSection, k) {
                    return _vm.group[section][subSection] &&
                      subSection !== "untitled"
                      ? _c(
                          "div",
                          { key: k, staticClass: "cardItem col-md-3" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row py-2 pl-3 mx-0 product-subsection-heading  rounded-top h-100"
                              },
                              [
                                _c("div", { staticClass: "col p-0" }, [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        attrs: {
                                          role: "heading",
                                          "aria-level": "4"
                                        }
                                      },
                                      [_vm._v(_vm._s(subSection))]
                                    ),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "delete",
                                      attrs: {
                                        href: "javascript:void(0);",
                                        "aria-label": _vm.ariaLabel(subSection)
                                      },
                                      on: {
                                        keydown: [
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.promptDeleteSection(
                                              "remove-claim-modal_" + k
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.promptDeleteSection(
                                              "remove-claim-modal_" + k
                                            )
                                          }
                                        ],
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.promptDeleteSection(
                                            "remove-claim-modal_" + k
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "b-modal",
                                  {
                                    ref: "remove-claim-modal_" + k,
                                    refInFor: true,
                                    attrs: {
                                      "hide-header": "",
                                      "hide-footer": "",
                                      "hide-header-close": "",
                                      "no-enforce-focus": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "Trapclaim",
                                      { attrs: { group: "remove-modal" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "remove-confirmation-box"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "remove-modal-message mb-3"
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "Are you sure you want to remove this claim?"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "remove-modal-sep mt-1 mb-1"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "remove-btn-box" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "mt-3 remove-btn-cancel remove-cust-btn",
                                                    attrs: { block: "" },
                                                    on: {
                                                      keydown: [
                                                        function($event) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          return _vm.closeRemoveModalProperty(
                                                            "remove-claim-modal_" +
                                                              k
                                                          )
                                                        },
                                                        function($event) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "space",
                                                              32,
                                                              $event.key,
                                                              [" ", "Spacebar"]
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          return _vm.closeRemoveModalProperty(
                                                            "remove-claim-modal_" +
                                                              k
                                                          )
                                                        }
                                                      ],
                                                      click: function($event) {
                                                        return _vm.closeRemoveModalProperty(
                                                          "remove-claim-modal_" +
                                                            k
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "mt-3 remove-btn-confirm remove-cust-btn",
                                                    attrs: { block: "" },
                                                    on: {
                                                      keydown: [
                                                        function($event) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          return _vm.deleteSection(
                                                            subSection,
                                                            "remove-claim-modal_" +
                                                              k
                                                          )
                                                        },
                                                        function($event) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "space",
                                                              32,
                                                              $event.key,
                                                              [" ", "Spacebar"]
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          return _vm.deleteSection(
                                                            subSection,
                                                            "remove-claim-modal_" +
                                                              k
                                                          )
                                                        }
                                                      ],
                                                      click: function($event) {
                                                        return _vm.deleteSection(
                                                          subSection,
                                                          "remove-claim-modal_" +
                                                            k
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Remove"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-fluid",
                    staticStyle: { "margin-top": "0" }
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "carousel-vehicle",
                        refInFor: true,
                        staticClass: "row scrolling-wrapper pb-3",
                        attrs: { id: "carousel-vehicle" }
                      },
                      _vm._l(_vm.subSections, function(subSection, l) {
                        return _vm.group[section][subSection] &&
                          subSection !== "untitled"
                          ? _c(
                              "div",
                              { key: l, staticClass: "cardItem col-md-3 mb-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-row mx-0 pt-3 accordPanel shadow-sm rounded-bottom"
                                  },
                                  [
                                    _c("div", { staticClass: "col-12 px-0" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-row ml-3 mr-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-12 px-0" },
                                            [
                                              _c(
                                                "div",
                                                _vm._l(
                                                  _vm.subSubSections,
                                                  function(subSubSection, l) {
                                                    return _vm.group[section][
                                                      subSection
                                                    ][subSubSection]
                                                      ? _c(
                                                          "div",
                                                          {
                                                            key: l,
                                                            class:
                                                              subSubSection ===
                                                              "untitled"
                                                                ? "col-md-12 px-0"
                                                                : "col-12 col-lg-6 px-0 mb-3"
                                                          },
                                                          [
                                                            subSubSection !==
                                                            "untitled"
                                                              ? _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "form-row mx-0"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col py-1 pl-2 my-2 ml-3 bg-ltblue text-white"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  subSubSection
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.group[
                                                                section
                                                              ][subSection][
                                                                subSubSection
                                                              ],
                                                              function(
                                                                fieldData,
                                                                m
                                                              ) {
                                                                return _c(
                                                                  "form-block",
                                                                  {
                                                                    key: m,
                                                                    staticClass:
                                                                      "form-group mx-3",
                                                                    attrs: {
                                                                      formdata: fieldData,
                                                                      formIndex: m
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(0, true)
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ]
                )
              ]
            ],
            2
          ),
          _vm._v(" "),
          section !== "untitled"
            ? _c(
                "div",
                {
                  staticClass:
                    "section-heading-bottom py-2 mt-1 mb-2 pl-2 text-white rounded-top"
                },
                [
                  _c("section-heading", {
                    attrs: {
                      section: section,
                      pageData: _vm.pageData,
                      headingType: "bottom"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "form-row py-3 mx-0 mt-4 product-subsection-heading rounded-bottom"
      },
      [
        _c("div", {
          staticClass: "col p-0 text-right mr-3 smaller-font-content"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4096c064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4096c064","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/layouts/LayoutHorizontal.vue
// module id = null
// module chunks = 